<template>
  <div
    class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-3 ts-space-y-3"
  >
    <!-- <div class="ts-grid ts-grid-cols-2 ts-gap-3">
      <div>
        <label>{{ $t('wholesale.discount') }}</label>
        <input
          v-model.number="model.discount"
          type="number"
          class="form-control"
        />
        <div class="validate" v-if="errors.has('discount')">
          {{ errors.first('discount') }}
        </div>
      </div>
      <div>
        <label>{{ $t('wholesale.grandTotal') }}</label>
        <input
          v-model.number="model.grand_total"
          type="number"
          class="form-control"
          readonly
        />
        <div class="validate" v-if="errors.has('grand_total')">
          {{ errors.first('grand_total') }}
        </div>
      </div>
    </div> -->
    <div class="ts-grid ts-grid-cols-2 ts-gap-3">
      <div>
        <label class="required">{{ $t('wholesale.amountPaid') }}</label>
        <input
          v-model.number="model.amount_paid"
          type="text"
          class="form-control"
          @input="onPaidInput"
        />
        <div class="validate" v-if="errors.has('amount_paid')">
          {{ errors.first('amount_paid') }}
        </div>
      </div>
      <div>
        <label class="required">{{ $t('wholesale.amountDue') }}</label>
        <input
          v-model.number="model.amount_due"
          type="text"
          class="form-control"
          readonly
        />
        <div class="validate" v-if="errors.has('amount_due')">
          {{ errors.first('amount_due') }}
        </div>
      </div>
    </div>
    <div>
      <label class="required">{{ $t('wholesale.nextPayment') }}</label>
      <a-date-picker
        v-model="model.next_payment_date"
        format="DD-MM-YYYY"
        valueFormat="DD-MM-YYYY"
        class="ts-w-full"
        :disabled="disableDate"
      ></a-date-picker>
      <div class="validate" v-if="errors.has('next_payment_date')">
        {{ errors.first('next_payment_date') }}
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { round } from 'lodash'

export default {
  name: 'exchangeRate',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  computed: {
    disableDate() {
      return !this.model.amount_due > 0
    },
    default_precision() {
      return this.$store.state.authUser.sys_setting.decimal_digit
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    onPaidInput() {
      if (this.model.payment_method_id != 1) {
        this.model.bank_transfer = this.model.amount_paid
      } else {
        this.model.bank_transfer = 0
      }

      this.model.amount_due = _.round(
        this.model.grand_total - this.model.amount_paid,
        this.default_precision
      )
      if (!this.disableDate || this.model.amount_paid == 0) {
        this.model.next_payment_date = moment()
          .add(this.model.credit_day, 'days')
          .format('DD-MM-YYYY')
      }
      if (this.model.amount_due == 0) {
        this.model.next_payment_date = ''
      }
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
